module.exports = __webpack_public_path__ + "static/media/lang-add-video.9a0329f3.png";